import _ from 'lodash';
import { FETCH_PRODUCTS } from '../../reducer/actions/loadProducts.graphql';
import { loadProductSuccess } from '../../reducer/actions/loadProductSuccess';
import { selectProduct } from '../../reducer/actions/selectProduct';
import { ContextType } from './../context';
import { Action, registerReducer } from './../reducer';
import { Carrier, Product, State } from './../state';

const NAME = 'loadProducts';

interface Data extends Action {
    carrier: Carrier,
}

registerReducer(NAME, reducer);

function reducer(state: State, data: Data): State {

    return {
        ...state,
        product: {
            ...state.product,
            loading: true,
            selected: undefined,
        }
    };
}

export const loadProducts = (context: ContextType, data: Omit<Data, 'type'>) => {
    context.dispatch({ type: NAME });

    context.apolloGraphQL.client.watchQuery({
        query: FETCH_PRODUCTS,
        fetchPolicy: 'no-cache',
        variables: {
            carrierID: data.carrier.id,
        }
    })
        .subscribe(({ data }) => {

            if (data) {
                const products: Product[] = [];
                _.forEach(data.products.all.edges, (edge) => {
                    products.push(productFragment2Product(edge.node));
                });

                loadProductSuccess(context, { products });
                if (!context.state.product.selected && products.length === 1) {
                    selectProduct(context, { product: products[0] });
                }
            }
        });
};

export const productFragment2Product = (product: any): Product => (
    {
        id: product.id,
        sku: product.sku,
        name: product.name,
        details: product.details,
        price: product.price,
        variablePrice: product.variablePrice,
        minPrice: product.minPrice,
        maxPrice: product.maxPrice,
        discount: product.discount,
        discountMode: product.discountMode,
        inputs: product.inputs,
        country: product.carrier ? product.carrier.country : undefined,
        type: product.__typename,
        planType: product.planType,
        isPIN: product.isPIN,
        carrier: product.carrier ? {
            ...product.carrier,
            color: product.carrier.bgColor || '#26A69A',
            logoUrl: product.carrier.logoUrl || 'data:image/jpeg;base64,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'
        } : undefined,
    }
);
